import {lazyWithRetry} from '../lazyWithRetry/lazyWithRetry';

export const LazyUserList = lazyWithRetry(() => import('./userList'));
